import React, { forwardRef } from 'react';

import { Icon, Tooltip } from '@chakra-ui/react';
import {
  ChatCircleDots,
  EnvelopeSimple,
  MicrosoftTeamsLogo,
  Notification,
  Phone,
  SlackLogo,
  WhatsappLogo,
} from '@phosphor-icons/react';
import PropTypes from 'prop-types';

const icons = {
  email: [
    'Email',
    <Icon
      as={EnvelopeSimple}
      boxSize="4"
      key="email"
    />,
  ],
  slack: [
    'Slack',
    <Icon as={SlackLogo} boxSize="4" key="slack" />,
  ],
  sms: [
    'SMS',
    <Icon
      as={ChatCircleDots}
      boxSize="4"
      key="sms"
    />,
  ],
  voice: [
    'Voice',
    <Icon as={Phone} boxSize="4" key="voice" />,
  ],
  apns: [
    'Push',
    <Icon
      as={Notification}
      boxSize="4"
      key="apns"
    />,
  ],
  fcm: [
    'Push',
    <Icon
      as={Notification}
      boxSize="4"
      color="content.secondary"
      key="fcm"
    />,
  ],
  whats_app: [
    'WhatsApp',
    <Icon
      as={WhatsappLogo}
      boxSize="4"
      color="content.secondary"
      key="whats_app"
    />,
  ],
  microsoft_teams: [
    'Microsoft Teams',
    <Icon
      as={MicrosoftTeamsLogo}
      boxSize="4"
      color="content.secondary"
      key="microsoft_teams"
    />,
  ],
};

export const NotificationIcon = ({ type }) => {
  const [tooltipText, icon] = icons[type];

  if (!icon) return null;

  const SpecificIcon = forwardRef(({ children, ...rest }, ref) => (
    <span ref={ref} {...rest}>
      {children}
    </span>
  ));

  SpecificIcon.displayName = 'SpecificIcon';

  return (
    <Tooltip placement="top" hasArrow label={tooltipText}>
      <SpecificIcon>{icon}</SpecificIcon>
    </Tooltip>
  );
};

NotificationIcon.propTypes = {
  type: PropTypes.string.isRequired,
};
